import { FormStepId } from 'shared/config/formStepId';

import type { StepDescription } from '../types';

export const stepsDescriptions: StepDescription[] = [
  { formId: FormStepId.CreditPurposeInfo },
  { formId: FormStepId.ContactsInfo },
  { formId: FormStepId.PassportInfo },
  { formId: FormStepId.WorkplaceInfo },
  { formId: FormStepId.AdditionalInfo },
];
